<template>
  <div class="home w">
    <!-- 头部开始 -->
    <div class="header-box">
      <div class="header-nav">
        <div @click="clickCatalogue()">文档库</div>
        <div v-if="currentCatalogue.length >= 1">></div>
        <div
          @click="clickCatalogue(item, index)"
          class=""
          v-for="(item, index) in currentCatalogue"
          :key="index"
        >
          <span>{{ item }}</span>
          <span v-if="index < currentCatalogue.length - 1">></span>
        </div>
      </div>
      <div class="screen-box-div">
        <div class="screen-box">
          <div class="screen-search">
            <el-input
              style="width: 200px"
              v-model="inputSearch"
              placeholder="请输入内容"
            ></el-input>
            <i @click="search" class="iconfont icon-sousuo"></i>
          </div>
          <div class="screen-type">
            <div class="type-box creen-type-comm">
              <div
                :class="currentSortIndex == 1 ? 'active' : ''"
                @click="sort('filename', 1)"
              >
                文件名
              </div>
              <div>|</div>
              <div
                :class="currentSortIndex == 2 ? 'active' : ''"
                @click="sort('filtype', 2)"
              >
                类型
              </div>
            </div>
            <div class="sort-box creen-type-comm">
              <div
                :class="currentSortIndex1 == 1 ? 'active' : ''"
                @click="sort('positive', 1)"
              >
                正序
              </div>
              <div>|</div>
              <div
                :class="currentSortIndex1 == 2 ? 'active' : ''"
                @click="sort('inverted', 2)"
              >
                倒序
              </div>
            </div>
          </div>
        </div>
        <div></div>
        <div class="">
          
            <!-- <el-button type="primary" @click="Alldownload"
            >全部下载本目录文件</el-button
          > -->
          <el-button type="primary" @click="amendPasswordClick"
            >修改密码</el-button
          >
          <el-button type="danger" @click="exit">退出登录</el-button>
        </div>
      </div>
    </div>
    <!-- 头部结束 -->
    <div class="">
      <!-- 提示语 -->
      <!-- <div class="reminder-box">
        <div class="">
          点击文件即可下载，不可批量下载。每一部分都有单独准备的压缩包
        </div>
      </div> -->
      <!-- 提示语 -->
      <!-- 文件列表 -->
      <div class="file-box">
        <div class="file-box-list" v-if="filterKey.length >= 1">
          <template v-for="(item, index) in filterKey">
            <div
              @click="toTier(item, index)"
              @contextmenu.prevent.stop="openMenu($event,item)"
              :key="index"
              class="file-list-item"
              :title="item.name"
              v-if="item"
            >
              <img :src="getFileIcon(item.name)" alt="" srcset="" style="width:45px;height:45px">
              <!-- <i class="iconfont font-icon" :class="iconMatching(item)"></i> -->
              <div
                class="file-list-item-name"
                style="font-size: 20px; text-align: center"
              >
                {{ item.name }}
              </div>
            </div>
          </template>
        </div>
        <div v-else style="text-align: center">暂无数据</div>
      </div>
      <!-- 文件列表 -->
    </div>

    <popUpModel
      ref="popUpModel"
      :customStyle="'height: auto; width: auto;padding: 30px;'"
    >
      <div>
        <img :src="currentUrl" style="height: 60vh" alt="" />
      </div>
      <div style="margin-top: 30px">
        <el-button @click="quxiao">取消</el-button>
        <el-button type="primary" @click="download">下载</el-button>
      </div>
    </popUpModel>

    <div id="download"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import { dateFormat } from '@/utils/time'
import { FILEAPI } from '@/utils/request.js'
import popUpModel from '@/components/pop-up-model'
import path from 'path'

// import JSZip from 'jszip'
import FileSaver from 'file-saver'
import axios from 'axios'
// const downloadList = {}
const getFile = url => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: 'http://staticsr.shurenzixun.com/mls/files/' + url, // 跨域配置
      responseType: 'blob'
    })
      .then(data => {
        resolve(data.data)
      })
      .catch(error => {
        reject(error.toString())
      })
  })
}
export default {
  name: 'Home',
  components: {
    popUpModel
  },
  data() {
    return {
      downLoadMsg: '', // 消息
      currentPath: '', // 当前路径
      currentUrl: '', // 当前访问的图片url
      imgCurrentName: '', // 当前访问的图片路径
      filesList: [], // 文件列表

      inputSearch: '',
      // 过滤
      filterKey: [],
      filterKey1: [],
      // 当前目录
      currentCatalogue: [],
      // 当前名称
      currentName: '',
      currentSortIndex: 1,
      currentSortIndex1: 1,
      currentSorttype: 'filename',
      iconMap: {
        'docx': 'http://upan.shurenzixun.com/static/icon/docx.png',
        'doc': 'http://upan.shurenzixun.com/static/icon/doc.png',
        'xlsx': 'http://upan.shurenzixun.com/static/icon/xlsx.png',
        'pptx': 'http://upan.shurenzixun.com/static/icon/pptx.png',
        'pdf': 'http://upan.shurenzixun.com/static/icon/pdf.png',
        'xls': 'http://upan.shurenzixun.com/static/icon/xls.png',
        'mp4': 'http://upan.shurenzixun.com/static/icon/mp4.png',
        'jpg': 'http://upan.shurenzixun.com/static/icon/jpg.png',
        'jpeg': 'http://upan.shurenzixun.com/static/icon/jpeg.png',
        'png': 'http://upan.shurenzixun.com/static/icon/png.png',
        'ai': 'http://upan.shurenzixun.com/static/icon/ai.png',
        'cdr': 'http://upan.shurenzixun.com/static/icon/cdr.png',
        'psd': 'http://upan.shurenzixun.com/static/icon/psd.png',
        'zip': 'http://upan.shurenzixun.com/static/icon/zip.png',
        'rar': 'http://upan.shurenzixun.com/static/icon/rar.png',
        '7z': 'http://upan.shurenzixun.com/static/icon/7z.png',
        'apz': 'http://upan.shurenzixun.com/static/icon/apz.png',
        'ar': 'http://upan.shurenzixun.com/static/icon/ar.png',
        'bz': 'http://upan.shurenzixun.com/static/icon/bz.png',
        'car': 'http://upan.shurenzixun.com/static/icon/car.png',
        'dar': 'http://upan.shurenzixun.com/static/icon/dar.png',
        'gz': 'http://upan.shurenzixun.com/static/icon/gz.png',
        'txt': 'http://upan.shurenzixun.com/static/icon/txt.png'
      }
    }
  },
  mounted () {
    // 获取文件列表
    this.getFileList()
  },
  methods: {
    openMenu (e, item) {
      if (!this.checkFile(item.name)) {
        // this.$alert('是否下载本文夹的内容【下载文件夹会导致内存暴增，可能会引起浏览器的崩溃，建议您单个下载或在先观看】', '提示', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     if (action === 'confirm') {
        //       // 下载本路径所有的文件
        //       this.downLoadAll(this.getFielFullPath(item.name))
        //     }
        //   }
        // })
      } else {
        this.downloadOne(this.getFielFullPath(item.name))
      }
    },
    // 获取文件的路径
    getFileDir (name) {
      return path.dirname(name)
    },
    // 下载单个文件
    downloadOne (currentPath) {
      let link = document.createElement('a') // 创建a标签
      link.style.display = 'none' // 将a标签隐藏
      link.href = 'http://staticsr.shurenzixun.com/mls/files/' + currentPath // 给a标签添加下载链接
      link.setAttribute('download', this.getFileName(currentPath))
      link.setAttribute('target', '_blank')
      document.body.appendChild(link)
      link.click() // 执行a标签

      // getFile(currentPath).then(res => {
      //   FileSaver.saveAs(res, this.getFileName(currentPath))
      // })
    },
    // 下载目录下的所有文件，不会递归下载
    // downLoadAll (dir) {
    //   // console.log('dir=', dir)
    //   // 赛选出匹配该文件夹的文件
    //   // 下载，并安排好目录
    //   const downloadPath = []
    //   for (let i = 0; i < this.filesList.length; i++) {
    //     const element = this.filesList[i]
    //     if (element.fileName.indexOf(dir) === 0) { // 前缀完全匹配
    //       // 是文件夹下的直接文件
    //       if (this.getFileDir(element.fileName) === dir) {
    //         downloadPath.push(element.fileName)
    //       }
    //     }
    //   }
    //   // console.log('应该下载的内容', downloadPath)
    //   // '/mlsfile/00打开文件必读！！！！/02师训课件/03.早会流程.pptx',
    //   const zip = new JSZip()
    //   const cache = {}
    //   const promises = []
    //   downloadPath.forEach(item => {
    //     // this.downLoadMsg = '正在下载：' + item
    //     let tempName = item
    //     const promise = getFile(item).then(data => {
    //       this.downLoadMsg = '正在下载：' + tempName
    //       // 下载文件, 并存成ArrayBuffer对象
    //       // const arrName = item.split('/')
    //       const fileName = item.replace(dir + '/', '') // arrName[arrName.length - 1] // 获取文件名
    //       console.log('filename = ', item, fileName)
    //       zip.file(fileName, data, { binary: true }) // 逐个添加文件
    //       cache[fileName] = data
    //     })
    //     promises.push(promise)
    //   })
    //   Promise.all(promises).then(() => {
    //     this.downLoadMsg = '全部下载完毕，正在打包'
    //     zip.generateAsync({ type: 'blob' }).then(content => {
    //       this.downLoadMsg = '打包完毕，已开启浏览器的下载任务'
    //       // 生成二进制流
    //       FileSaver.saveAs(content, this.getFileName(dir) + '.zip') // 利用file-saver保存文件  自定义文件名
    //     })
    //   }).catch(err => {
    //     console.log(err)
    //     this.downLoadMsg = '下载出现异常:' + err
    //   })
    // },

    getFileName (dir) {
      const tempArr = dir.split('/')
      return tempArr[tempArr.length - 1]
    },
    // 获取uri的文件类型
    getFileType (uri) {
      uri = uri.toLowerCase()
      let extName = path.extname(uri)
      if (extName === '') {
        return ''
      }
      extName = extName.replace('.', '')
      if (this.iconMap[extName] !== undefined) {
        return extName
      }
      return ''
    },
    // 获取文件的icon
    getFileIcon (uri) {
      uri = uri.toLowerCase()
      let fileType = this.getFileType(uri)
      let res
      if (fileType === '') {
        res = 'http://upan.shurenzixun.com/static/icon/dir.png'
      } else {
        // 文件名不在里面的 同意算作文件夹
        res = this.iconMap[fileType]
      }
      return res
    },
    // 判断是否是文件
    checkFile (uri) {
      return this.getFileType(uri) !== ''
    },
    // 判断是否office
    isOffice (uri) {
      let fileType = this.getFileType(uri)
      let office = ['docx', 'doc', 'xlsx', 'pptx', 'xls']
      return office.indexOf(fileType) !== -1
    },
    isPdf (uri) {
      let fileType = this.getFileType(uri)
      return fileType === 'pdf'
    },
    isImg (uri) {
      let fileType = this.getFileType(uri)
      let imgtypes = ['jpg', 'png', 'gif']
      return imgtypes.indexOf(fileType) !== -1
    },
    quxiao () {
      this.$refs['popUpModel'].close()
    },
    dateFormat (date, type) {
      return dateFormat(date, type)
    },
    // 修改密码
    amendPasswordClick () {
      // this.isAmendPassword = true
      this.$router.push({
        path: '/amend-password'
      })
    },
    // 退出登录
    exit () {
      this.$confirm('是否是真的退出, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
          localStorage.setItem('token', '')
          this.$router.push({
            path: '/login'
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    // 获取文件列表
    async getFileList () {
      var data = await this.$api.getFileList()
      this.filesList = data.data
      // console.log(this.filesList)
      // 第一次初始化过滤
      this.initData()
      // 默认文件名排序
      this.filenameSort()
    },

    // 排序
    sort (type, active) {
      this.currentSorttype = type
      if (type === 'filename' || type === 'filtype') {
        this.currentSortIndex = active
      } else {
        this.currentSortIndex1 = active
      }
      if (type === 'filename') {
        // 文件名排序
        this.filenameSort()
      } else if (type === 'filtype') {
        this.typeAscending()
        // 类型
      } else if (type === 'positive') {
        // 文件名正序
        if (this.currentSortIndex === 1) {
          this.filterKey.sort((a, b) => {
            return a.name.localeCompare(b.name)
          })
        } else {
          this.typeAscending()
        }
      } else if (type === 'inverted') {
        // 文件名倒序
        if (this.currentSortIndex === 1) {
          this.filterKey.sort(this.fileNameInverted('name'))
        } else {
          this.typeDescending()
        }
      }
    },
    // 文件类型升序
    typeAscending () {
      var typesfile = []
      var catalogues = []
      this.filterKey.forEach((item) => {
        if (this.checkFile(item.name)) {
          typesfile.push(item)
        } else {
          catalogues.push(item)
        }
      })

      // 文件
      typesfile.sort((a, b) => {
        let test = a.name.split('.')
        let test1 = b.name.split('.')
        return test[test.length - 1].localeCompare(test1.length - 1)
      })
      // 目录
      catalogues.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
      this.filterKey = [...typesfile, ...catalogues]
    },
    // 文件类型降序
    typeDescending () {
      var typesfile = []
      var catalogues = []
      this.filterKey.forEach((item) => {
        if (this.checkFile(item.name)) {
          typesfile.push(item)
        } else {
          catalogues.push(item)
        }
      })
      typesfile.sort((a, b) => {
        let test = a.name.split('.')
        let test1 = b.name.split('.')
        return test[test.length - 1] < test1[test1.length - 1] ? 1 : -1
      })
      catalogues.sort(this.fileNameInverted('name'))
      this.filterKey = [...catalogues, ...typesfile]
    },
    // 文件名排序
    filenameSort () {
      let data = this.filterKey
      if (this.currentSortIndex1 === 2) {
        // 降序
        data.sort(this.fileNameInverted('name'))
      } else {
        // 升序
        data.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
      }
    },
    fileNameInverted (name) {
      return function (o, p) {
        var a, b
        if (typeof o === 'object' && typeof p === 'object' && o && p) {
          a = o[name]
          b = p[name]
          if (a === b) {
            return 0
          }
          if (typeof a === typeof b) {
            return a < b ? 1 : -1
          }
          return typeof a < typeof b ? -1 : 1
        } else {
          throw new Error('error')
        }
      }
    },
    // 搜索
    search () {
      if (!this.inputSearch) {
        if (this.currentCatalogue.length >= 1) {
          this.filterKey = this.filterKey1
        } else {
          this.initData()
        }
        return
      }
      let tempfilterKey1 = this.filterKey1
      let searchCont = []
      if (tempfilterKey1.length <= 0) {
        searchCont = this.filterKey.filter((item) => {
          return item.name.indexOf(this.inputSearch) !== -1
        })
      } else {
        searchCont = tempfilterKey1.filter((item) => {
          return item.name.indexOf(this.inputSearch) !== -1
        })
      }
      if (this.filterKey.length >= 1) {
        this.filterKey1 = Object.assign([], this.filterKey)
      }
      this.filterKey = searchCont
    },
    // 点击目录
    clickCatalogue (item, index) {
      const tempArr = []
      for (let i = 0; i <= index; i++) {
        tempArr[i] = this.currentCatalogue[i]
      }
      this.currentPath = tempArr.join('/')

      this.filterKey1 = []
      if (!item) {
        this.currentCatalogue.splice(0)
        this.filterKey = []
        this.initData()
        this.sort(this.currentSorttype, this.currentSortIndex)
        return
      }
      this.currentCatalogue.splice(index)
      let tempData = {
        name: item
      }
      this.filterFileTier(tempData)
      this.sort(this.currentSorttype, this.currentSortIndex)
    },
    initData () {
      var filter = {}
      this.filesList.length >= 1 &&
        this.filesList.forEach((item) => {
          let filterCont = item.fileName.split('/')
          filter[filterCont[0]] = item.createDate
        })

      let tempfilterKey = []
      for (const key in filter) {
        if (Object.hasOwnProperty.call(filter, key)) {
          const element = filter[key]
          tempfilterKey.push({
            name: key,
            createDate: element
          })
        }
      }
      this.filterKey = tempfilterKey
    },
    // 严格匹配
    matchingStrict (name) {
      let is = false
      this.filterKey.forEach((item) => {
        if (item.name === name) {
          is = true
        }
      })
      return is
    },
    download () {
      // 图片的下载
      let currentPath = this.getFielFullPath(this.imgCurrentName)
      getFile(currentPath).then(res => {
        FileSaver.saveAs(res, this.getFileName(currentPath))
      })
      // this.downloadOne(this.getFielFullPath(this.imgCurrentName))
      // let link = document.createElement('a') // 创建a标签
      // link.style.display = 'none' // 将a标签隐藏
      // link.href = this.currentUrl // 给a标签添加下载链接
      // link.setAttribute('download', path.basename(this.currentUrl))
      // link.setAttribute('target', '_blank')
      // document.body.appendChild(link)
      // link.click() // 执行a标签
    },
    getFielFullPath (name) {
      let currentPath = this.currentPath
      if (!currentPath) {
        currentPath = name
      } else {
        currentPath = currentPath + '/' + name
      }
      return currentPath
    },
    getLink (href) {
      let link = document.createElement('a') // 创建a标签
      link.style.display = 'none' // 将a标签隐藏
      link.href = href
      link.setAttribute('download', '')
      link.setAttribute('target', '_blank')
      document.body.appendChild(link)
      return link
    },
    // 点击文件
    toTier (item) {
      if (this.checkFile(item.name)) { // 文件处理
        // 图片预览
        if (this.isImg(item.name)) {
          this.currentUrl = FILEAPI + this.getFielFullPath(item.name)
          this.imgCurrentName = item.name
          this.$refs['popUpModel'].open()
          return
        }
        // office 文件在线预览
        if (this.isOffice(item.name)) {
          let link = this.getLink('https://view.officeapps.live.com/op/view.aspx?src=' + decodeURI(FILEAPI + this.getFielFullPath(item.name)))
          link.click() // 执行a标签
          return
        }
        // pdf 直接打开
        if (this.isPdf(item.name)) {
          let link = this.getLink(FILEAPI + this.getFielFullPath(item.name))
          link.click() // 执行a标签
          return
        }
        // 其他文件直接下载
        this.downloadOne(this.getFielFullPath(item.name))
        return
      }
      this.currentPath = this.getFielFullPath(item.name)
      this.currentName = item
      this.filterFileTier(this.currentName)
      let type = this.currentSorttype
      if (type === 'filename' || type === 'filtype') {
        this.sort(this.currentSorttype, this.currentSortIndex)
      } else {
        this.sort(this.currentSorttype, this.currentSortIndex1)
      }
    },
    matchingFilter (item) {
      let repStr = item.fileName.replace(this.currentCatalogue.join('/'), '')
      let filterCont = repStr.replace(/^\//, '').split('/')
      return filterCont[0]
    },
    // 过滤层级
    filterFileTier (name) {
      this.currentCatalogue.push(name.name)
      var filterArr = []
      this.filesList.forEach((item, index) => {
        if (item.fileName.indexOf(this.currentCatalogue.join('/') + '/') === 0) {
          filterArr[this.matchingFilter(item, index, filterArr)] =
            item.createDate
        }
      })
      let tempfilterKey = []
      for (const key in filterArr) {
        if (Object.hasOwnProperty.call(filterArr, key)) {
          const element = filterArr[key]
          tempfilterKey.push({
            name: key,
            createDate: element
          })
        }
      }
      this.filterKey = tempfilterKey.filter((item) => {
        return item.name
      })
    }
  }
}
</script>

<style lang='scss' >
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background-color: rgb(3, 125, 243);;
  color: white;
}
.header-box {
  .el-button {
    font-size: 17px;
  }
}
</style>
<style lang="scss" scoped>
$color: rgb(25, 175, 241);
.screen-box-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.home {
  padding-top: 30px;
  .file-log-box {
    // height: 100vh;
    overflow: auto;
    .file-log-title {
      padding: 10px;
      font-size: 20px;
      color: $color;
    }
    .file-log-body {
      .file-log {
        font-size: 17px;
        padding: 10px;
        border-top: 1px dashed #000;
      }
    }
  }
  // 头部开始
  .header-box {
    .header-nav {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      color: $color;

      div {
        margin-right: 10px;
        cursor: pointer;
        font-size: 25px;

        span {
          margin-right: 10px;
        }
      }
    }

    .screen-box {
      display: flex;
      align-items: center;

      .screen-search {
        display: flex;
        align-items: center;
        margin-right: 60px;

        i {
          font-size: 30px;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      .screen-type {
        display: flex;

        .creen-type-comm {
          margin: 0 20px;
          display: flex;

          div {
            margin-right: 5px;
            cursor: pointer;
            font-size: 20px;
          }
        }

        .active {
          color: $color;
        }
      }
    }
  }

  // 头部结束

  // 提示语
  .reminder-box {
    width: 700px;
    background: rgb(255, 223, 37);
    padding: 5px 0 5px 10px;
    border-radius: 2px;
    margin-top: 10px;
    box-shadow: 10px 5px 8px #c0bfbf;
  }

  // 提示语

  // 文件列表
  .file-box {
    margin-top: 40px;
    height: 80vh;
    overflow: auto;
    .file-box-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .file-list-item {
        width: 163px;
        height: 160px;
        display: flex;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        .file-list-item-name {
          font-size: 20px;
          text-align: center;
          width: 80%;
          // height: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          word-break: break-all;
        }
        // overflow: hidden;
        // white-space: nowrap;
        // text-overflow: ellipsis;
        .font-icon {
          font-size: 45px;
          margin-bottom: 10px;
        }
      }
    }
  }

  // 文件列表
}
</style>
